import { useDeviceType } from '~/context/common/DeviceContext';
import { width } from '../constants';

export const sliderOptions = {
  desktop: {
    cellSpacing: 60,
    imgWidth: width.desktop,
    slidesToScroll: 3,
    slidesToShow: 3
  },
  tablet: {
    cellSpacing: 30,
    imgWidth: width.tablet,
    slidesToScroll: 1,
    slidesToShow: 1
  },
  mobile: {
    cellSpacing: 20,
    imgWidth: width.mobile,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 175
  }
};

export default function useSliderConfig() {
  const { isMobile, isTablet } = useDeviceType();

  const { tablet, mobile, desktop } = sliderOptions;

  if (isTablet) {
    return tablet;
  }

  if (isMobile) {
    return mobile;
  }

  return desktop;
}
